import type { DeepReadonly } from "@vue/runtime-dom";
import type { Authentication } from "~/shared/interfaces/system.interface";
import type { IUser } from "~/shared/interfaces/user.interface";

export const useAuthentication = (a?: Authentication) =>
    useState<Authentication>("authenticationState", () => a || { authenticated: false });

type Principal = {
    authentication: DeepReadonly<Ref<Authentication>>;
    principal: Ref<IUser>;
    // slot: Ref<Betting>,
    // userStatus: Ref<UserAlarmInfo>,
    isAuthenticated: Ref<Readonly<boolean>>;
    login: (_: Pick<Authentication, "principal" | "jwt">) => void;
    setPrincipal: (user: IUser) => void;
    logout: () => void;
    reset: () => void;
};
export const usePrincipal = (): Principal => {
    const { $io, $bus } = useNuxtApp();
    const authenticationCookie = useCookie<Authentication>("authenticationCookie", {
        path: "/",
        default: () => ({ authenticated: false }),
    });
    const authentication = useAuthentication(authenticationCookie.value);
    const principal = useState<IUser>("principal");
    const isAuthenticated = computed(() => authentication.value.authenticated || false);
    const router = useRouter();

    const login = (_authentication: Pick<Authentication, "principal" | "jwt">) => {
        authentication.value = { ..._authentication, authenticated: true };
        authenticationCookie.value = { authenticated: true, jwt: _authentication.jwt };
        setPrincipal(_authentication.principal as IUser);
    };

    const setPrincipal = (user: IUser) => {
        principal.value = user;
    };

    const logout = () => {
        $io.disconnect();
        authenticationCookie.value = authentication.value = { authenticated: false };
        $io.connect();
        $bus.$emit("user:logout");
        router.push("/");
    };

    const reset = () => {
        authenticationCookie.value = authentication.value = { authenticated: false };
    };

    return { authentication: readonly(authentication), isAuthenticated, principal, login, logout, reset, setPrincipal };
};
